module.exports = __webpack_public_path__ + "img/person.061f27ed.png";